import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from './loginStaticStyles';
import LoginWorkflow from '../LoginWorkflow';

const LoginStatic = props => (
	<Modal>
		<LoginWorkflow modalMode {...props} />
	</Modal>
);

LoginStatic.propTypes = {
	accountCookied: PropTypes.bool,
	captchaReady: PropTypes.bool,
	clearErrors: PropTypes.func,
	createAccountError: PropTypes.bool,
	createAccountErrorCode: PropTypes.string,
	createAccountHandler: PropTypes.func,
	createAccountMsg: PropTypes.string,
	facebookClick: PropTypes.func,
	forgortError: PropTypes.bool,
	forgotHandler: PropTypes.func,
	forgotSuccess: PropTypes.bool,
	googleClick: PropTypes.func,
	isCheckout: PropTypes.bool,
	onChangeView: PropTypes.func,
	onGuestCheckoutSelected: PropTypes.func,
	outsideUsa: PropTypes.bool,
	signInHandler: PropTypes.func,
	signInError: PropTypes.bool,
};

export default LoginStatic;
